import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { StorageService } from '../../core/services/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../core/services/login.service';
import { CommonService } from 'src/app/core/services/common.service';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-report-issue',
  templateUrl: './report-issue.component.html',
  styleUrls: ['./report-issue.component.css']
})
export class ReportIssueComponent implements OnInit {
  public reportIssueForm!: FormGroup;
  public reportIssueErrResp!: string;
  isSubmitted: boolean = false;
  userDetails: any;
  isArabic!: boolean;
  isIssueRaised: boolean = false;
  fileToUpload: File | null = null;
  fileToUploadBase64: any;
  fileSize: any;
  fileName: any;
  showSizeErr: any;
  isFileUploaded!: any;
  fileUploadErr!: boolean;
  fileTypeErr!: boolean;
  ticketNumber!: string;
  createdTicketNumber!: string;
  disabledBtn: any;
  serverErr: any;
  modalRefDeactivate!: BsModalRef;
  // isSlashTitle:any;
  // isSlashDesc:any;
  incidentId: any;
  isViewMode: boolean = false;
  uploadedFile: any;
  uploadedFileName: any;
  uploadedFileType: any;
  caseType: string = 'General Issues';
  @ViewChild('attachment') fileInput!: ElementRef;
  constructor(private route: Router, public formBuilder: FormBuilder, private commonService: CommonService,
    private storageService: StorageService, private loginService: LoginService,
    private modalService: BsModalService,
    private assessmentService: AssessmentService, private location: Location,
    private activatedRoute: ActivatedRoute) {
    let details = this.activatedRoute.snapshot.paramMap.get('details');
    if (details) {
      this.incidentId = this.commonService.decryptUsingAES256(details);
    }
  }

  ngOnInit(): void {
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.reportIssueForm = this.formBuilder.group({
      issueTitle: ['', [Validators.required]],
      issueDesc: ['', [Validators.required]],
      resolutionComment: ['', []]
    });

    if (this.incidentId) {
      this.isViewMode = true;
      const rqstBody =
      {
        contactguid: this.userDetails?.contactguid,
        assessmentunitguid: this.userDetails?.assessmentUnitValue,
        incidentId: this.incidentId,
        caseType: this.caseType

      }
      this.assessmentService.fetchCaseDetails(rqstBody)
        .subscribe((data: any) => {
          let decryptedData = this.commonService.decryptUsingAES256(data?.data);
          //console.log("Case details report:", decryptedData);
          if (decryptedData?.caseDetails) {
            this.reportIssueForm.controls['issueTitle'].setValue(decryptedData?.caseDetails?.title);
            this.reportIssueForm.controls['issueTitle'].disable();
            this.reportIssueForm.controls['issueDesc'].setValue(decryptedData?.caseDetails?.description);
            this.reportIssueForm.controls['issueDesc'].disable();
            this.reportIssueForm.controls['resolutionComment'].setValue(decryptedData?.caseDetails?.resolutionComment);
            this.reportIssueForm.controls['resolutionComment'].disable();
            this.createdTicketNumber = decryptedData?.caseDetails?.ticketNumber;
          }
        });
      const rqstBodyForFiles = {
        responseguid: this.incidentId,
        type: "incident"
      }
      this.assessmentService.fetchUploadedFile(rqstBodyForFiles)
        .subscribe((data: any) => {
          let decryptedData = this.commonService.decryptUsingAES256(data?.data);
          //console.log("Case files report:", decryptedData);

          let resp = JSON.parse(JSON.stringify(decryptedData));
          //console.log('finally files in report issue: ', resp);
          this.uploadedFile = resp?.documentbody;
          if (this.uploadedFile || resp?.filename) {
            this.uploadedFileName = resp?.filename;
            this.uploadedFileType = resp?.mimetype;
            //this.downloadFile(resp?.documentbody, resp?.mimetype, this.uploadedFileName);
          }
        })
    }
  }

  get comments() {
    return this.reportIssueForm.controls['resolutionComment'].value;
  }

  reportIssue() {
    this.isSubmitted = true;
    if (this.reportIssueForm.valid && this.isFileUploaded) {
      const reportIssueData = {
        title: this.reportIssueForm.value.issueTitle,
        description: this.reportIssueForm.value.issueDesc,
        contactId: this.userDetails.contactguid,
        caseType: 'General Issues',
        assessmentUnit: this.userDetails.assessmentUnitValue
      }
      //console.log(reportIssueData);
      this.disabledBtn = true;
      this.loginService.createCase(reportIssueData).subscribe((data: any) => {
        //console.log('report issue data: ', data);
        let decryptedData = this.commonService.decryptUsingAES256(data?.data);
        if (decryptedData?.isCaseCreated === true) {
          let incidentId = decryptedData.incidentId;
          let ticketNumber = decryptedData.ticketNumber;
          this.callUploadFile(incidentId, ticketNumber);
        } else if (data?.error) {
          this.reportIssueErrResp = data?.error.errMsg;
          this.disabledBtn = false;
          window.scrollTo(0, 0);
        }
      }, (error: any) => {
        //console.log(error);
        if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
          this.showDeactivationPopup();
        } else {
          this.serverErr = error?.body?.error;
        }
        this.disabledBtn = false;
        window.scrollTo(0, 0);
      });
    }
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRefDeactivate = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  callUploadFile(incidentId: any, ticketNumber: any) {
    const rqstBody = {
      filename: this.fileName,
      documentBody: this.fileToUploadBase64,
      subjectId: ticketNumber,
      responseguid: incidentId,
      notesType: 'cases'
    }
    //console.log(rqstBody);
    this.disabledBtn = true;
    this.assessmentService.uploadFileToServer(rqstBody).subscribe((data4: any) => {
      let decryptedData3 = this.commonService.decryptUsingAES256(data4?.data);
      //console.log(decryptedData3);
      if (decryptedData3?.isUploaded === true) {
        this.fileUploadErr = false;
        this.isSubmitted = false;
        this.isIssueRaised = true;
        this.ticketNumber = ticketNumber;
        this.reportIssueForm.reset();
        this.fileInput.nativeElement.value = "";
        this.fileToUpload = null;
        this.fileToUploadBase64 = undefined;
        this.fileSize = undefined;
        this.fileName = undefined;
        this.showSizeErr = undefined;
        this.isFileUploaded = undefined;
        this.fileUploadErr = false;
        this.fileTypeErr = false;
        this.disabledBtn = false;
      } else {
        this.fileUploadErr = true;
        this.isFileUploaded = false;
        this.disabledBtn = false;
      }
      window.scrollTo(0, 0);
    }, (error: any) => {
      this.serverErr = error?.body?.error;
      this.disabledBtn = false;
      window.scrollTo(0, 0);
    });
  }

  handleFileInput(evt: any) {
    this.isFileUploaded = undefined;
    let files = evt.target.files;
    this.fileToUpload = files[0];
    //console.log(files[0])
    let ext = files[0]?.name.split('.').pop();
    if (ext == 'doc' || ext == 'docx' || ext == 'pdf' || ext == 'txt' || ext == 'jpg' || ext == 'jpeg' || ext == 'png') {
      this.fileName = files[0]?.name;
      this.fileSize = files[0]?.size;
      //console.log('filename: ', this.fileName);
      this.fileTypeErr = false;
      this.onFileUpload();

    } else {
      this.isFileUploaded = false;
      this.fileTypeErr = true;
    }
  }

  onFileUpload() {
    if (this.fileSize > 20 * 1024 * 1024) {
      this.showSizeErr = true;
      this.isFileUploaded = false;
    } else if (this.fileToUpload) {  // <-- null check here
      this.showSizeErr = false;
      this.commonService.fileToBase64(this.fileToUpload).then(result => {
        const pureBase64 = result?.split(',')[1]; // remove prefix
        // console.log('pureBase64: ', pureBase64);
        this.fileToUploadBase64 = pureBase64;
        this.isFileUploaded = true;
      });
    } else {
      console.error('No file selected to upload.');
      this.isFileUploaded = false;
    }
  }

  // checkBackslash(event: any) {
  // this.isSlashTitle = false;
  // this.isSlashDesc = false;
  // if (event.key == '\\' || event.which == 220 || event.key == ';' || event.which == 186) {
  //   event.preventDefault();
  //   return;
  // }
  // }
  handleFileLinkClick() {
    this.downloadFile(this.uploadedFile, this.uploadedFileType, this.uploadedFileName);
  }
  downloadFile(linkSource: any, fileType: any, fileName: any) {
    const downloadLink = document.createElement('a');
    linkSource = 'data:' + fileType + ';base64,' + linkSource;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
  goToLastPage() {
    this.location.back();
  }

}
